<template>
  <div :style="containerStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Scroller',
  props: {
    maxHeight: [Number, String],
    height: [Number, String],
    hideHorizontal: Boolean
  },
  computed: {
    containerStyle() {
      var style = {
        'overflow-y': 'auto'
      }
      if(this.hideHorizontal)
        style['overflow-x'] = 'hidden'

      if(this.maxHeight) {
        style['max-height'] = this.maxHeight + 'px'
      }
      if(this.height) {
        style['height'] = this.height + 'px'
      }
      return style
    }
  }
}
</script>
